/** Internal matcher shape used by the resolver */
export type CodeMatcher<Code extends string> = {
  match: string
  code: Code
}

export function getCode<
  MatchedCode extends string,
  FallbackCode extends string
>(
  message: string,
  matchers: Readonly<CodeMatcher<MatchedCode>[]>,
  fallback: FallbackCode
) {
  const normalized = message.toLowerCase()
  const matched = matchers.find((m) => normalized.includes(m.match))
  return matched?.code ?? fallback
}

export async function extractResponseMessage(error: unknown): Promise<string> {
  if (error instanceof Response) {
    try {
      const body = await error.json()
      return body?.errors?.[0]?.message ?? body?.message ?? ''
    } catch {
      return ''
    }
  }
  if (error instanceof Error) return error.message
  return ''
}

export function extractResponseStatus(error: unknown): number {
  if (error instanceof Response) return error.status
  return 0
}

export async function handleScenario<
  Code extends string,
  Resolver extends (state: unknown) => Promise<Code>
>(
  resolver: Resolver,
  state: unknown,
  onResolvedCode: (code: Awaited<ReturnType<Resolver>>) => void
) {
  const code = await resolver(state)
  onResolvedCode(code as Awaited<ReturnType<typeof resolver>>)
}
